export interface ChatMember {
  _id: string;
  pseudo: string;
  name?: string;
  lastName?: string;
  avatar?: string;
}

// Nom affiché d'un membre : « prénom nom » s'il les a renseignés, sinon son pseudo
export function memberName(member: ChatMember | null | undefined): string {
  const fullName = [member?.name, member?.lastName].map(part => (part || '').trim()).filter(Boolean).join(' ');
  return fullName || member?.pseudo || '';
}

export interface ChatMessage {
  _id: string;
  conversationKey: string;
  from: string;
  to: string;
  text: string;
  createdAt: string;
  readAt?: string;
}

export interface ChatFriend {
  user: ChatMember;
  since: string;
  online: boolean;
  lastMessage: { text: string; from: string; createdAt: string } | null;
  unread: number;
}

export interface ChatRequest {
  _id: string;
  user: ChatMember;
  createdAt: string;
}

export interface ChatRelations {
  friends: ChatFriend[];
  incoming: ChatRequest[];
  outgoing: ChatRequest[];
}

export type ChatRelation = 'friend' | 'incoming' | 'outgoing' | 'none';

export interface ChatSearchResult {
  user: ChatMember;
  relation: ChatRelation;
  requestId: string | null;
}

export interface ChatUnread {
  messages: number;
  requests: number;
}

export interface ChatMessagesPage {
  messages: ChatMessage[];
  hasMore: boolean;
}

// Événement temps réel « relations » : demande reçue/envoyée, acceptée, annulée, ami retiré
export interface ChatRelationEvent {
  type: 'request' | 'sent' | 'accepted' | 'cancelled' | 'removed';
  user: ChatMember | null;
}

export interface ChatReadEvent {
  conversationKey: string;
  reader: string;
  readAt: string;
}

export interface ChatTypingEvent {
  from: string;
  typing: boolean;
}
